import { render } from "./visitMuseum.vue?vue&type=template&id=736cefd0&scoped=true"
import script from "./visitMuseum.vue?vue&type=script&lang=js"
export * from "./visitMuseum.vue?vue&type=script&lang=js"

import "./visitMuseum.vue?vue&type=style&index=0&id=736cefd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736cefd0"]])

export default __exports__